<template lang="pug">
select.form-control.c-select
    option(value="" disabled) Select Invoice
    option(
        v-for="receive in receiveList"
        :value="receive.id"
        :key="receive.id"
    ) Invoice: {{ receive.invoice }}, Cost: {{ receive.supplier_price }}, Qty Left: {{ receive.qty_left }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    props: {
        outlet_id: {
            type: Number,
            default: 0,
        },
        stock_id: {
            type: Number,
            default: 0,
        },
        supplier_id: {
            type: Number,
            default: 0,
        },
    },

    computed: {
        ...mapGetters('stockReturn', ['receiveList']),
    },

    // created() {
    //     this.loadReceiveList();
    // },

    methods: {
        ...mapActions('stockReturn', ['getReceiveList']),

        // loadReceiveList() {
        //     const params = {
        //         outlet_id: this.outlet_id,
        //         stock_id: this.stock_id,
        //         supplier_id: this.supplier_id,
        //     };
        //
        //     this.getReceiveList(params);
        // },

        // selectReceive(e) {
        //     let receive_id = e.target.value;
        //     let receive = this.receiveList.find(r => r.id == receive_id);
        // },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/selector/stock-receive-selector.vue